/**
 * Dispara download de arquivo a partir de resposta axios (responseType: 'blob').
 */
export async function downloadBlobResponse(requestPromise, filenameFallback, mimeType) {
    const response = await requestPromise;
    const disposition = response.headers['content-disposition'];
    let filename = filenameFallback;

    if (disposition) {
        const match = /filename\*?=(?:UTF-8'')?"?([^";\n]+)"?/i.exec(disposition);
        if (match?.[1]) {
            filename = decodeURIComponent(match[1].trim());
        }
    }

    const blob = new Blob([response.data], { type: mimeType });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

/**
 * Dispara download de CSV a partir de resposta axios (responseType: 'blob').
 */
export function downloadReportCsv(requestPromise, filenameFallback = 'relatorio.csv') {
    return downloadBlobResponse(requestPromise, filenameFallback, 'text/csv;charset=utf-8');
}
